(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-bundle-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-wd-bundle-picker]').forEach(function (picker) {
    var errorEl = picker.querySelector('[data-wd-bundle-error]');

    // The native Dawn "Add to cart" form, wherever it is on this page.
    var nativeForm = document.querySelector('form[data-type="add-to-cart-form"]');

    function setNativeField(name, value) {
      if (!nativeForm) return;
      // Reuse a field Dawn already rendered with this name (e.g. its default
      // hidden "id" input) if one exists, rather than creating a duplicate.
      var existing = nativeForm.querySelector('[name="' + name + '"]');
      if (existing) {
        existing.value = value;
        return;
      }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-wd-native-field', name);
      nativeForm.appendChild(input);
      input.value = value;
    }

    var swatchGroups = picker.querySelectorAll('[data-wd-swatch-group]');
    swatchGroups.forEach(function (group) {
      var groupName = group.getAttribute('data-wd-swatch-group');
      var localHiddenInput = picker.querySelector('[data-wd-hidden-input="' + groupName + '"]');

      group.querySelectorAll('[data-wd-swatch-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('.wd-bundle__swatch').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');

          var value = btn.getAttribute('data-wd-swatch-value');
          if (localHiddenInput) localHiddenInput.value = value;
          setNativeField(groupName, value);

          var field = group.closest('.wd-bundle__field');
          if (field) field.classList.remove('has-error');
          if (errorEl) errorEl.hidden = true;
        });
      });
    });

    if (!nativeForm) return;

    // Validate our selections before letting the native Add to Cart form submit.
    // Capture phase so this runs before Dawn's own submit handler.
    nativeForm.addEventListener('submit', function (e) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      var firstMissingField = null;
      swatchGroups.forEach(function (group) {
        var groupName = group.getAttribute('data-wd-swatch-group');
        var localHiddenInput = picker.querySelector('[data-wd-hidden-input="' + groupName + '"]');
        var field = group.closest('.wd-bundle__field');
        if (!localHiddenInput || !localHiddenInput.value) {
          if (field) field.classList.add('has-error');
          if (!firstMissingField) firstMissingField = field;
        }
      });

      if (firstMissingField) {
        e.preventDefault();
        e.stopImmediatePropagation();
        firstMissingField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (errorEl) {
          errorEl.textContent = 'Please complete all the selections above before adding to cart.';
          errorEl.hidden = false;
        }
      }
    }, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-find-my-size"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-wd-fit]').forEach(function (root) {
    var sizes = [];
    var prices = {};
    try { sizes = JSON.parse(root.getAttribute('data-sizes') || '[]'); } catch (e) {}
    try {
      JSON.parse(root.getAttribute('data-prices') || '[]').forEach(function (p) {
        prices[p.size] = p.price;
      });
    } catch (e) {}

    var shopUrl = root.getAttribute('data-shop-url') || '/collections/all';
    var messengerUrl = root.getAttribute('data-messenger-url') || '';
    var currency = root.getAttribute('data-currency') || '';

    var form = root.querySelector('[data-wd-fit-form]');
    var errorEl = root.querySelector('[data-wd-fit-error]');
    var resultEl = root.querySelector('[data-wd-fit-result]');
    var heightCmBox = root.querySelector('[data-height-cm]');
    var heightFtInBox = root.querySelector('[data-height-ftin]');
    var weightSuffix = root.querySelector('[data-weight-suffix]');

    var heightUnit = 'cm';
    var weightUnit = 'kg';

    function setPressed(buttons, activeValue, attr) {
      buttons.forEach(function (b) {
        var on = b.getAttribute(attr) === activeValue;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    var heightButtons = Array.prototype.slice.call(root.querySelectorAll('[data-height-unit]'));
    var weightButtons = Array.prototype.slice.call(root.querySelectorAll('[data-weight-unit]'));

    heightButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        heightUnit = btn.getAttribute('data-height-unit');
        setPressed(heightButtons, heightUnit, 'data-height-unit');
        heightCmBox.hidden = heightUnit !== 'cm';
        heightFtInBox.hidden = heightUnit !== 'ftin';
      });
    });
    weightButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        weightUnit = btn.getAttribute('data-weight-unit');
        setPressed(weightButtons, weightUnit, 'data-weight-unit');
        if (weightSuffix) weightSuffix.textContent = weightUnit;
      });
    });

    function showError(message) {
      resultEl.hidden = true;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function addText(parent, tag, className, text) {
      var el = document.createElement(tag);
      el.className = className;
      el.textContent = text;
      parent.appendChild(el);
      return el;
    }

    function addLink(parent, href, label, outline) {
      var a = document.createElement('a');
      a.className = 'wd-fit__btn' + (outline ? ' wd-fit__btn--outline' : '');
      a.href = href;
      a.textContent = label;
      parent.appendChild(a);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      var heightCm;
      if (heightUnit === 'cm') {
        heightCm = parseFloat(root.querySelector('[data-input-height-cm]').value);
      } else {
        var ft = parseFloat(root.querySelector('[data-input-ft]').value);
        var inch = parseFloat(root.querySelector('[data-input-in]').value) || 0;
        heightCm = isNaN(ft) ? NaN : ft * 30.48 + inch * 2.54;
      }
      var weightRaw = parseFloat(root.querySelector('[data-input-weight]').value);
      var weightKg = weightUnit === 'kg' ? weightRaw : weightRaw * 0.45359237;

      if (isNaN(heightCm) || isNaN(weightKg)) {
        showError('Please type your height and your weight.');
        return;
      }
      if (heightCm < 100 || heightCm > 230 || weightKg < 25 || weightKg > 400) {
        showError('Please check your numbers. They look too small or too big.');
        return;
      }
      if (!sizes.length) {
        showError('Sorry, this tool is not ready yet.');
        return;
      }

      var byWeight = -1;
      var byHeight = -1;
      for (var i = 0; i < sizes.length; i++) {
        if (byWeight === -1 && weightKg <= sizes[i].w) byWeight = i;
        if (byHeight === -1 && heightCm <= sizes[i].h) byHeight = i;
      }

      resultEl.textContent = '';
      var actions;

      if (byWeight === -1 || byHeight === -1) {
        addText(resultEl, 'p', 'wd-fit__result-label', 'Let us help you');
        addText(resultEl, 'p', 'wd-fit__result-text', 'Your measurements are beyond our standard sizes. Please message us and we will see how we can help you get a good fit.');
        actions = document.createElement('div');
        actions.className = 'wd-fit__actions';
        if (messengerUrl) addLink(actions, messengerUrl, 'Message us on Messenger', false);
        resultEl.appendChild(actions);
        resultEl.hidden = false;
        return;
      }

      var index = Math.max(byWeight, byHeight);
      var offset = parseInt(root.querySelector('[data-input-pref]').value, 10) || 0;
      index = Math.min(sizes.length - 1, Math.max(0, index + offset));
      var size = sizes[index].size;

      addText(resultEl, 'p', 'wd-fit__result-label', 'Your suggested size is');
      addText(resultEl, 'p', 'wd-fit__result-size', size);
      addText(resultEl, 'p', 'wd-fit__result-text',
        'Based on ' + Math.round(heightCm) + ' cm and ' + Math.round(weightKg) + ' kg.');
      if (prices[size]) {
        addText(resultEl, 'p', 'wd-fit__result-price', 'Price for size ' + size + ': ' + currency + prices[size]);
      }

      actions = document.createElement('div');
      actions.className = 'wd-fit__actions';
      addLink(actions, shopUrl, 'Shop shirts', false);
      if (messengerUrl) addLink(actions, messengerUrl, 'Not sure? Message us', true);
      resultEl.appendChild(actions);

      resultEl.hidden = false;
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-sticky-cart"]) return;
  try {
    
(function () {
  var bar = document.getElementById('wd-sticky-cart');
  if (!bar) return;

  var stickyBtn = document.getElementById('wd-sticky-cart-btn');
  var nativeForm = document.querySelector('form[data-type="add-to-cart-form"]');
  var nativeBtn = nativeForm ? nativeForm.querySelector('button[type="submit"]') : null;

  if (stickyBtn && nativeBtn) {
    stickyBtn.addEventListener('click', function () {
      // Forward to the real button so all existing validation
      // (size, bundle colors, etc.) still runs exactly as normal.
      nativeBtn.click();
    });
  }

  // Watch the native button (or its form, as a fallback) and show the
  // sticky bar once it scrolls out of view.
  var watchTarget = nativeBtn || nativeForm;
  if (!watchTarget || typeof IntersectionObserver === 'undefined') return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0 }
  );
  observer.observe(watchTarget);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weardaily-exit-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.wd-exit-popup').forEach(function (popup) {
    var SESSION_KEY = 'wdExitPopupShownThisSession';   // resets every new visit/tab
    var PURCHASED_KEY = 'wdHasPurchased';               // permanent — set once they actually complete an order

    var requireCartItems = popup.getAttribute('data-require-cart-items') === 'true';
    var mobileDelaySeconds = parseInt(popup.getAttribute('data-mobile-delay'), 10) || 0;
    var isReturningCustomer = popup.getAttribute('data-is-returning-customer') === 'true';

    var path = window.location.pathname;
    var onOrderConfirmation = path.indexOf('/thank') !== -1 || path.indexOf('/thank_you') !== -1 || path.indexOf('/orders') === 0;
    var skipPaths = ['/cart', '/checkout'];
    var onSkipPath = skipPaths.some(function (p) { return path.indexOf(p) === 0; }) || onOrderConfirmation;

    // Landing on the real order-confirmation page is the one reliable signal
    // that a purchase actually completed — mark it permanently so the popup
    // never bothers this visitor again, on any future visit.
    if (onOrderConfirmation) {
      try { window.localStorage.setItem(PURCHASED_KEY, 'true'); } catch (e) {}
    }

    var hasPurchased = false;
    try { hasPurchased = window.localStorage.getItem(PURCHASED_KEY) === 'true'; } catch (e) {}

    var shownThisSession = false;
    try { shownThisSession = window.sessionStorage.getItem(SESSION_KEY) === 'true'; } catch (e) {}

    if (onSkipPath || hasPurchased || isReturningCustomer || shownThisSession) return;

    var closeButtons = popup.querySelectorAll('[data-exit-close]');
    var copyBtn = popup.querySelector('[id^="wd-exit-popup-copy-"]');
    var urgencyEl = popup.querySelector('.wd-exit-popup__urgency');
    var timerEl = popup.querySelector('[id^="wd-exit-popup-timer-"]');
    var triggered = false;
    var checking = false;
    var timerInterval = null;

    // Countdown persists per browser session (not per page view) so it keeps
    // ticking down correctly even if the visitor navigates or refreshes
    // while the popup is open.
    function startUrgencyTimer() {
      if (!urgencyEl || !timerEl) return;
      var minutes = parseInt(urgencyEl.getAttribute('data-urgency-minutes'), 10) || 0;
      if (minutes <= 0) return;
      var DEADLINE_KEY = 'wdExitPopupDeadline';
      var deadline;
      try {
        var stored = window.sessionStorage.getItem(DEADLINE_KEY);
        deadline = stored ? parseInt(stored, 10) : null;
      } catch (e) { deadline = null; }

      if (!deadline || isNaN(deadline)) {
        deadline = Date.now() + minutes * 60 * 1000;
        try { window.sessionStorage.setItem(DEADLINE_KEY, String(deadline)); } catch (e) {}
      }

      function tick() {
        var remainingMs = deadline - Date.now();
        if (remainingMs <= 0) {
          timerEl.textContent = '00:00';
          timerEl.setAttribute('data-expired', 'true');
          if (timerInterval) clearInterval(timerInterval);
          return;
        }
        var totalSeconds = Math.floor(remainingMs / 1000);
        var mm = Math.floor(totalSeconds / 60);
        var ss = totalSeconds % 60;
        timerEl.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
      }

      tick();
      timerInterval = setInterval(tick, 1000);
    }

    function showPopup() {
      if (triggered) return;
      triggered = true;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      try { window.sessionStorage.setItem(SESSION_KEY, 'true'); } catch (e) {}
      startUrgencyTimer();
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    // Only show if the visitor actually has something sitting in their
    // cart right now — checked live via /cart.js at the moment of the
    // trigger, so it's accurate even if items were added via AJAX earlier
    // in this same page view without a full page reload.
    function maybeShowPopup() {
      if (triggered || checking) return;
      if (!requireCartItems) {
        showPopup();
        return;
      }
      checking = true;
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          checking = false;
          if (cart.item_count > 0) showPopup();
        })
        .catch(function () { checking = false; });
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', hidePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hidePopup();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            copyBtn.setAttribute('data-copied', 'true');
            setTimeout(function () {
              copyBtn.textContent = original;
              copyBtn.removeAttribute('data-copied');
            }, 1800);
          }).catch(function () {});
        }
      });
    }

    // Desktop exit-intent: mouse moves up toward the browser chrome (tab bar / close button)
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) maybeShowPopup();
    });

    // Mobile / fallback: no reliable mouse-exit signal, so use a time delay instead
    if (mobileDelaySeconds > 0) {
      setTimeout(maybeShowPopup, mobileDelaySeconds * 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
